var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabackup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.629 7.90816C12.3377 5.6135 10.373 3.8335 7.99967 3.8335C6.16234 3.8335 4.56634 4.9075 3.83767 6.60016C2.40567 7.02816 1.33301 8.38016 1.33301 9.8335C1.33301 11.6715 2.82834 13.1668 4.66634 13.1668H11.9997C13.4703 13.1668 14.6663 11.9708 14.6663 10.5002C14.6653 9.90257 14.4641 9.32255 14.0948 8.85272C13.7255 8.38288 13.2094 8.05033 12.629 7.90816Z",
    fill: "#1F242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabackup);
export default __webpack_public_path__ + "static/media/databackup.8caac56b456f272e6ff25f1c2238827d.svg";
export { ForwardRef as ReactComponent };